import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import addIcon from "../../assets/images/addSm.svg";
import minusIcon from "../../assets/images/minusIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { ChargesByMachine } from "../../services/ReduxTookit/Slice/CostManagementRedux";
import moment from "moment";
import { commonservices } from "../../services/CommonServices";
const ChargeByWorkflow = ({ data, startDate, endDate, mainLoading }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);

  const handleShowCollapse = (rowId) => {
    setExpandedRow(expandedRow === rowId ? null : rowId);
  };

  const MachineDataList = useSelector(
    (state) =>
      state?.costmanagement?.ChargesByMachineData?.data?.data?.data?.dataList1
  );

  useEffect(() => {
    if (expandedRow) {
      setLoading(true);
      dispatch(
        ChargesByMachine({
          startdate: moment(startDate).format("YYYY-MM-DD"),
          enddate: moment(endDate).format("YYYY-MM-DD"),
          workflowid: expandedRow,
        })
      )?.then(() => setLoading(false));
    }
  }, [expandedRow, startDate, endDate]);
  return (
    <div className="table-wrapper-main">
      <Table responsive>
        <thead>
          <th>Description</th>
          <th className="width175 text-center" style={{ whiteSpace: "nowrap" }}>Usage</th>
          <th className="text-end width140" style={{ whiteSpace: "nowrap" }}>Invoice Amount</th>
        </thead>
        <tbody>
          {mainLoading ? (
            <Loader type={LoaderType.TableRow} count={4} nooftd={3} />
          ) : (
            <>
              {data?.map((item, index) => {
                const isExpanded = expandedRow === item?.workflowid;

                return (
                  <React.Fragment key={item?.workflowid}>
                    <tr className="dark-bg">
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <>
                            <img
                              src={isExpanded ? minusIcon : addIcon}
                              alt="toggleIcon"
                              className="cursor-pointer"
                              onClick={() =>
                                handleShowCollapse(item?.workflowid)
                              }
                            />
                            <span>{item?.workflowname}</span>
                          </>
                        </div>
                      </td>
                      <td className="width175 text-center" style={{ whiteSpace: "nowrap" }}>
                        {commonservices.calculateDurationSec(
                          parseInt(item?.totaltime)
                        )}
                      </td>
                      <td className="text-end width140" style={{ whiteSpace: "nowrap" }}>
                        ${" "}
                        {commonservices.fnAmountDigitCount(
                          item?.consumptioncost,
                          5
                        )}
                      </td>
                    </tr>
                    {loading && isExpanded ? (
                      <Loader type={LoaderType.TableRow} count={4} nooftd={3} />
                    ) : (
                      <>
                        {" "}
                        {isExpanded &&
                          ["Starter", "Other", "Exit"].map((category) =>
                            MachineDataList?.filter((itm) =>
                              category === "Other"
                                ? itm?.machinename?.toUpperCase() !==
                                    "STARTER" &&
                                  itm?.machinename?.toUpperCase() !== "EXIT"
                                : itm?.machinename === category
                            )?.map((item_2, index_2) => {
                              return (
                                <tr className="dark-bg child-row">
                                  <td>
                                    <div>
                                      <span>{item_2?.machinename}</span>
                                    </div>
                                  </td>
                                  <td className="width175 text-center">
                                    {commonservices.calculateDurationSec(
                                      parseInt(item_2?.totaltime)
                                    )}
                                  </td>
                                  <td className="text-end width140">
                                    ${" "}
                                    {item_2?.consumptioncost
                                      ? commonservices.fnAmountDigitCount(
                                          item_2?.consumptioncost,
                                          5
                                        )
                                      : 0.0}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                      </>
                    )}
                  </React.Fragment>
                );
              })}
            </>
          )}
          {!mainLoading && (
            <tr className="dark-bg">
              <td>
                <b>Total</b>
              </td>
              <td></td>
              <td className="text-end width140 " style={{ whiteSpace: "nowrap" }}>
                ${" "}
                {commonservices.fnAmountDigitCount(
                  data?.reduce(
                    (total, items) =>
                      total + (parseFloat(items?.consumptioncost) || 0),
                    0
                  ),
                  5
                )}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default ChargeByWorkflow;
